// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YPERx","col":"styles_col__1TU6d"};